// Texto plano a partir de algo que PUEDE traer HTML.
//
// Por qué existe: durante mucho tiempo el alta de una respuesta guardó el MISMO HTML en
// `body_html` y en `body_text` (el INSERT pasaba el mismo parámetro a las dos columnas),
// así que el supuesto "texto plano" viene con <p> y <strong> adentro. Eso ya se corrigió
// en el alta, pero quedan ~1.100 mensajes viejos así — y los mails entrantes del cliente y
// los de WhatsApp tienen el mismo vicio.
//
// La regla que deja: donde se muestre texto SIN interpretar HTML (un resumen, una cita, un
// snippet), limpiar acá. La pantalla no puede depender de que el dato esté impecable.
export function toPlainText(valor) {
  const crudo = String(valor || '');
  if (!/<[a-zA-Z/][^>]*>/.test(crudo)) return crudo;
  try {
    return new DOMParser().parseFromString(crudo, 'text/html').body.textContent || '';
  } catch {
    return crudo.replace(/<[^>]*>/g, ' ');
  }
}

// Igual que arriba pero además colapsa espacios y recorta — para resúmenes de una línea.
export function toSnippet(valor, max = 110) {
  const txt = toPlainText(valor).replace(/\s+/g, ' ').trim();
  return txt.length > max ? `${txt.slice(0, max)}…` : txt;
}
